export default "__VITE_ASSET__Dxm_jutK__"